/* PromoVet DollarLabs order-form attribution.
 * Load once on ALL storefront pages, before </head>, without defer/async.
 * Marker: __pv_order_source = dl-order-form
 * Shopify Flow applies the completed-order tag: DL-Order-Form.
 * Based on DL order-form-storefront.js served on 2026-10-04.
 */
(function () {
  "use strict";
  if (window.__pvDlOrderTrackingInstalled || typeof window.fetch !== "function") return;
  window.__pvDlOrderTrackingInstalled = true;

  var originalFetch = window.fetch.bind(window);
  var sourceKey = "__pv_order_source";
  var sourceValue = "dl-order-form";
  var attempt = null;
  var sourceWrites = Promise.resolve();

  document.addEventListener("click", function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== "function") return;
    var button = target.closest(
      ".dollarlabs_order-form-mount .dl-of-dialog--lg " +
      ".dl-of-dialog-foot .dl-of-btn--primary"
    );
    if (button && !button.disabled) {
      attempt = {started: Date.now(), phase: "armed", oldKeys: null};
    }
  }, true);

  function activeAttempt() {
    if (attempt && Date.now() - attempt.started > 60000) attempt = null;
    return attempt;
  }

  function cartRequest(input, init) {
    var url, payload = null;
    try {
      url = new URL(typeof input === "string" ? input : input.url, window.location.href);
      if (init && typeof init.body === "string") payload = JSON.parse(init.body);
    } catch (_) {
      // Non-JSON bodies still represent ordinary cart mutations.
      try { url = new URL(typeof input === "string" ? input : input.url, window.location.href); }
      catch (_) { return null; }
    }
    if (url.origin !== window.location.origin) return null;
    var match = /\/cart(?:\/(add|change|update|clear))?\.js$/.exec(url.pathname);
    if (!match) return null;
    var method = String((init && init.method) || (input && input.method) || "GET").toUpperCase();
    if (!match[1] && method === "GET") return {action: "read", payload: payload};
    if (match[1] && method === "POST") return {action: match[1], payload: payload};
    return null;
  }

  function isCleanup(payload, current) {
    if (!payload || !payload.updates || !current.oldKeys || !current.oldKeys.length) return false;
    if (Object.keys(payload).length !== 1 || Array.isArray(payload.updates)) return false;
    var keys = Object.keys(payload.updates);
    return keys.length === current.oldKeys.length &&
      current.oldKeys.every(function (key) {
        return Object.prototype.hasOwnProperty.call(payload.updates, key);
      });
  }

  async function persistSource(value) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || "/";
    var attrs = {};
    attrs[sourceKey] = value;
    var controller = typeof AbortController === "function" ? new AbortController() : null;
    var timer = controller ? setTimeout(function () { controller.abort(); }, 4000) : null;
    try {
      var response = await originalFetch(root + "cart/update.js", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        credentials: "same-origin",
        body: JSON.stringify({attributes: attrs}),
        signal: controller ? controller.signal : undefined
      });
      if (!response.ok) throw new Error("cart attribute update returned " + response.status);
    } catch (error) {
      // Attribution failure must not turn a successful cart operation into a failure.
      console.warn("PromoVet order-form tracking: could not update source marker.", error);
    } finally {
      if (timer !== null) clearTimeout(timer);
    }
  }

  function writeSource(value) {
    sourceWrites = sourceWrites.then(function () { return persistSource(value); });
    return sourceWrites;
  }

  window.fetch = async function (input, init) {
    var req = cartRequest(input, init);
    var current = activeAttempt();
    var role = "ordinary";
    if (req && current) {
      if (req.action === "read" && current.phase === "armed") {
        role = "snapshot";
      } else if (req.action === "add" && current.phase === "armed" &&
          req.payload && Array.isArray(req.payload.items) && req.payload.items.length) {
        role = "form-add";
        current.phase = "adding";
      } else if (req.action === "update" && current.phase === "cleanup" &&
          isCleanup(req.payload, current)) {
        role = "form-cleanup";
        current.phase = "finishing";
      }
    }

    var response;
    try { response = await originalFetch(input, init); }
    catch (error) {
      if (role !== "ordinary" && attempt === current) attempt = null;
      throw error;
    }
    if (!req) return response;
    if (!response.ok) {
      if (role !== "ordinary" && attempt === current) attempt = null;
      return response;
    }

    if (role === "snapshot") {
      try {
        var cart = await response.clone().json();
        current.oldKeys = Array.isArray(cart.items) ? cart.items.map(function (item) {
          return String(item.key);
        }) : [];
      } catch (_) {
        current.oldKeys = null;
      }
    } else if (role === "form-add") {
      if (attempt === current) {
        if (current.oldKeys && current.oldKeys.length) {
          current.phase = "cleanup";
        } else {
          await writeSource(sourceValue);
          if (attempt === current) attempt = null;
        }
      }
    } else if (role === "form-cleanup") {
      await writeSource(sourceValue);
      if (attempt === current) attempt = null;
    } else if (req.action !== "read") {
      // An ordinary cart edit supersedes the form's attribution.
      attempt = null;
      await writeSource("");
    }
    return response;
  };
}());